<template>
    <div class="list-container">
        <entity-filter :title="title"
          v-show="!showAdvancedFilter"
          :data-list="groups"
          :searchable-fields="searchableFields"
          show-alphabetized-filter="true"
          :use-group="true"
          :group-by-options="groupByOptions" :actions="actions">
        </entity-filter>
        <generic-table
            v-show="!showAdvancedFilter"
            :title-map="titleMap"
            :table-body="groups"
            :end-point="endPoint">
        </generic-table>
    </div>
</template>

<script type="text/javascript">
import moment from 'moment'
import { mapState } from 'vuex';
import { bus, filter } from '../../main.js';
import store from '../../store.js';

import AdvancedFilter from '../AdvancedFilter';
import EntityFilter from '../EntityFilter';
import GenericTable from '../GenericTable';
import advancedSearchResults from '../advancedSearchResult';
import CreateButton from '../CreateButton';


export default {
  data() {
    return {
      title: {'icon': 'icon-group', 'name': "Groups"},
      titleMap: {
        'name': 'Name',
        'assigned': 'Assigned Users',
        // 'created': 'Created',
        'description': 'Description'
      },

      groupByOptions: {
        'name': 'Name',
        'assigned': 'Assigned Users',
        // 'created': 'Created',
        'description': 'Description',
      },

      endPoint: '/groups/{{ id }}/details',
      searchableFields: ['id', 'name', 'description'],
      label: 'Loading',
      actions: [
        { 
          name: 'Create Group', 
          url: "/groups/create",
          perm: "add_group"
        }
      ]
    };
  },

  watch: {
      // call this method if the route changes
      '$route': 'fetchAllGroups'
  },

  computed:{
    ...mapState({
        groups: function(state) {
          let data = state.groups;
          return this.formatGroupData(data, "MMMM DD YYYY, hh:mm A");
        },

        showAdvancedFilter: state => state.showAdvancedFilter,
        loading: state => state.loading
      })
  },
  
  mounted() {
    this.toggleSidebar();
  },

  beforeRouteEnter (to, from, next) {
    store.dispatch('resetErrors');
    store.dispatch('fetchAllGroups');
    next();
  },

  methods: {
    toggleSidebar(){
      bus.$emit('toggle-sidebar');
    },
    
    formatGroupData: function(data, format) {
      if (data == undefined)
        return [];

      data.forEach(function(_data) {
        let dirty_date = _data.created;
        let total = _data.users.length;

        // update/format key values in group list
        _data['created'] = (!dirty_date)? '--' : moment(dirty_date).format(format);
        _data['assigned'] = total;
      });
      return data;
    }
  },

  components:{
    GenericTable,
    EntityFilter,
    AdvancedFilter,
    advancedSearchResults,
    CreateButton
  }
};
</script>
<style lang="scss" scoped>
  h1{
    height: 21px;
  }
  .list-container{
    height: 100%;
  }
</style>


// WEBPACK FOOTER //
// src/components/group/GroupList.vue